module.exports = __webpack_public_path__ + "img/DJI_0556.4dab963d.jpg";